// features/branding — PUBLIC BARREL.

export type { BrandingConfig, BrandTint } from './types';
export { DEFAULT_BRANDING } from './constants';
export { brandingFromConfig } from './mapping';
export type { BackendBrandingConfig } from './mapping';
export { BrandingScope } from './components/BrandingScope';
export { TenantLogo } from './components/TenantLogo';
